export const translations = {
    fr: {
        // Sidebar
        nav_map: "Carte",
        nav_converter: "Convertisseur",
        nav_settings: "Paramètres",
        
        // Converter
        conv_title: "Convertisseur de devises",
        conv_subtitle: "Convertissez rapidement vos devises",
        equal: "égal",
        convert_now: "Convertir maintenant",
        
        // Settings
        settings_title: "Paramètres",
        settings_subtitle: "Configurez l'application selon vos préférences",
        
        section_appearance: "Apparence",
        theme_dark: "Thème sombre",
        theme_dark_desc: "Activer le mode sombre pour réduire la fatigue oculaire",
        
        section_language: "Langue",
        language_label: "Langue de l'interface",
        language_desc: "Choisissez votre langue préférée",
        
        section_preferences: "Préférences de conversion",
        default_currency: "Devise par défaut",
        default_currency_desc: "Devise utilisée par défaut pour les conversions",
        
        section_data: "Gestion des données",
        cache_data: "Cache de données",
        cache_data_desc: "Nettoyer les données mises en cache pour libérer de l'espace",
        refresh: "Actualiser",
        reset_app: "Réinitialiser l'application",
        reset_app_desc: "Effacer toutes les données et revenir aux paramètres d'usine",
        reset_btn: "Réinitialiser",
        
        // Map Page
        map_title: "Carte du monde",
        map_subtitle: "Cliquez sur un pays pour voir ses informations et sa devise",
        search_title: "Rechercher",
        search_placeholder: "Rechercher un pays...",
        no_country_selected: "Aucun pays sélectionné",
        click_map_hint: "Cliquez sur un pays sur la carte",
        
        // Country Panel
        population: "Population",
        capital: "Capitale",
        region: "Région",
        currency: "Devise",
        languages: "Langues",
        coordinates: "Coordonnées",
        no_detailed_info: "Informations détaillées non disponibles pour ce territoire.",
        map_error: "Impossible de charger la carte",
        symbol: "Symbole",
        exchange_rate: "Taux de change",
        convert_btn: "Convertir",
        
        // Notifications
        error_title: "Erreur",
        success_title: "Succès",
        info_title: "Information",
        loading: "Chargement...",
        detecting_location: "Détection de votre position...",
        loading_countries: "Chargement des pays...",
        location_detected: "Position détectée",
        location_error: "Géolocalisation non disponible",
        
        // Sidebar - specific
        credits: "© 2026 GeoCurrency",
        
        // About
        about_title: "À propos",
        about_desc: "GeoCurrency v1.0.0",
        about_subdesc: "Convertisseur de devises avec support géographique en temps réel",
        about_apis: "APIs et sources de données",
        about_apis_desc: "Informations détaillées sur les pays",
        about_apis_rates: "Taux de change en temps réel",
        about_apis_map: "Frontières géographiques des pays"
    },
    en: {
        // Sidebar
        nav_map: "Map",
        nav_converter: "Converter",
        nav_settings: "Settings",
        
        // Converter
        conv_title: "Currency Converter",
        conv_subtitle: "Quickly convert your currencies",
        equal: "equals",
        convert_now: "Convert Now",
        
        // Settings
        settings_title: "Settings",
        settings_subtitle: "Configure the application to your preferences",
        
        section_appearance: "Appearance",
        theme_dark: "Dark Theme",
        theme_dark_desc: "Enable dark mode to reduce eye strain",
        
        section_language: "Language",
        language_label: "Interface Language",
        language_desc: "Choose your preferred language",
        
        section_preferences: "Conversion Preferences",
        default_currency: "Default Currency",
        default_currency_desc: "Default currency used for conversions",
        
        section_data: "Data Management",
        cache_data: "Data Cache",
        cache_data_desc: "Clear cached data to free up space",
        refresh: "Refresh",
        reset_app: "Reset Application",
        reset_app_desc: "Clear all data and return to factory settings",
        reset_btn: "Reset",
        
        // Map Page
        map_title: "World Map",
        map_subtitle: "Click on a country to see its details and currency",
        search_title: "Search",
        search_placeholder: "Search for a country...",
        no_country_selected: "No country selected",
        click_map_hint: "Click on a country on the map",
        
        // Country Panel
        population: "Population",
        capital: "Capital",
        region: "Region",
        currency: "Currency",
        languages: "Languages",
        coordinates: "Coordinates",
        no_detailed_info: "Detailed information not available for this territory.",
        map_error: "Unable to load map",
        symbol: "Symbol",
        exchange_rate: "Exchange Rate",
        convert_btn: "Convert",
        
        // Notifications
        error_title: "Error",
        success_title: "Success",
        info_title: "Information",
        loading: "Loading...",
        detecting_location: "Detecting your location...",
        loading_countries: "Loading countries...",
        location_detected: "Location detected",
        location_error: "Location not available",
        
        // Sidebar - specific
        credits: "© 2026 GeoCurrency",
        
        // About
        about_title: "About",
        about_desc: "GeoCurrency v1.0.0",
        about_subdesc: "Currency converter with real-time geographic support",
        about_apis: "APIs and Data Sources",
        about_apis_desc: "Detailed country information",
        about_apis_rates: "Real-time exchange rates",
        about_apis_map: "Geographic country borders"
    }
};

export const getCurrentLang = () => {
    return localStorage.getItem('geocurrency-lang') || 'fr';
};

export const setLang = (lang) => {
    localStorage.setItem('geocurrency-lang', lang);
};

export const t = (key) => {
    const lang = getCurrentLang();
    return translations[lang][key] || key;
};
